import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import ServiceDetailsMain from "./ServiceDetailsMain";
import Footer from "../../components/Footer";

const ServiceDetails = () => {
  return (
    <>
      <HeaderFour />

      <ServiceDetailsMain />

      <Footer />
    </>
  );
};

export default ServiceDetails;
